<template>
  <div class="text-center">
    <span aria-hidden="true" class="spinner-border text-dark" />
    <p>Carregando dados ...</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingData',
}
</script>
